import styled from 'styled-components';

export const Col = styled.div<{ isWide?: boolean }>`
  flex: ${(props) => (props.isWide ? 1.5 : 1)};
  margin-right: 16px;
  flex-direction: column;
  overflow: hidden;
`;
